import React from 'react';
import { Link } from 'react-router-dom'

const UserMenu: React.FC = () => {

  return(
        <li className="dropdown">
          <a className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">BANCA
          </a>
          <ul className="dropdown-menu">
            <li>
              <Link to="/user" className="user">
                Gerenciar Usuários
              </Link>
            </li>
          </ul>
        </li>
    )
}

export default UserMenu;
